import { jsx } from 'react/jsx-runtime';
import '../../../Hero/index.js';
import '../SectionInsight/index.js';
import '../../../Tutorial/index.js';
import '../../../Card/index.js';
import '../../../Banner/index.js';
import '../../../BlogPost/index.js';
import '../../../Plugins/index.js';
import '../../../Event/index.js';
import '../../../Practice/index.js';
import { Grid } from '@sketch/components';
import { convertSize } from '../../convertSize.js';
import Guide from '../../../Tutorial/Tutorial.js';
import Hero from '../../../Hero/Hero.js';
import SectionInsight from '../SectionInsight/SectionInsight.js';
import Card from '../../../Card/Card.js';
import Banner from '../../../Banner/Banner.js';
import BlogPost from '../../../BlogPost/BlogPost.js';
import Plugins from '../../../Plugins/Plugins.js';
import Event from '../../../Event/Event.js';
import Practice from '../../../Practice/Practice.js';
import { useHero } from '../../../Hero/useHero.js';

// Helpers
const COMPONENTS = {
    TUTORIAL: Guide,
    HERO: Hero,
    INSIGHT: SectionInsight,
    CARD: Card,
    BANNER: Banner,
    BLOG_POST: BlogPost,
    PLUGINS: Plugins,
    EVENT: Event,
    PRACTICE: Practice,
};
/**
 *  Items
 *
 * Responsible for rendering the content of Sections
 */
const Items = ({ item, context, }) => {
    const { dismissedHeroes, dismissHero } = useHero();
    if (item.__typename !== 'Item') {
        return null;
    }
    // Do not render if dismissed
    if (dismissedHeroes.includes(item.id))
        return null;
    if (item.type === 'HERO') {
        return (jsx(Grid.Column, Object.assign({}, convertSize(item.size), { children: jsx(Hero, Object.assign({}, item, { context: context, onDismiss: item.dismissable ? dismissHero : undefined })) }), item.id));
    }
    const Component = COMPONENTS[item.type];
    return (jsx(Grid.Column, Object.assign({}, convertSize(item.size), { children: jsx(Component, Object.assign({}, item)) }), item.id));
};

export { Items as default };
